import { render, staticRenderFns } from "./stockist-menu.vue?vue&type=template&id=35f0d8cf&"
import script from "./stockist-menu.vue?vue&type=script&lang=js&"
export * from "./stockist-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports